// extracted by mini-css-extract-plugin
module.exports = {"container":"Navigation_container__1SN3a","navLink":"Navigation_navLink__2YrAp","avctiveNavLink":"Navigation_avctiveNavLink__1l_lB"};